import { Button, FlexBox } from '@dixa/lib-shared-habla';
import { sizes } from '@dixa/lib-shared-tokens';
import { ampli } from 'lib-shared-tracking';
import { PropsWithClassName } from 'lib-shared-types-utils';
import { useCallback } from 'react';

import { useAppSearchParams } from 'utils/url/useAppSearchParams';

import { ConversationsAgentFilter } from './components/agent/conversationsAgentFilter';
import { ConversationsChannelFilter } from './components/channel/conversationsChannelFilter';
import { ConversationsContactFilter } from './components/contact/conversationsContactFilter';
import { ConversationsDirectionFilter } from './components/direction/conversationsDirectionFilter';
import { ConversationsQueueFilter } from './components/queue/conversationsQueueFilter';
import { ConversationsStatusFilter } from './components/status/conversationsStatusFilter';

type ConversationsFiltersToolbarProps = PropsWithClassName;

/** Represents the conversations filters toolbar component. */
export const ConversationsFiltersToolbar = ({
  className,
}: ConversationsFiltersToolbarProps): JSX.Element => {
  const { unsetParams } = useAppSearchParams('/conversations');

  /** Handles clearing all filters. */
  const handleClearAll = useCallback(() => {
    unsetParams([
      'agent',
      'assigned',
      'channel',
      'direction',
      'limit',
      'offset',
      'queue',
      'queued',
      'requester',
      'status',
    ]);

    ampli.conversationsFilterClearAllClicked();
  }, [unsetParams]);

  return (
    <FlexBox
      className={className}
      flexWrap="wrap"
      justifyContent="flex-end"
      gap={sizes.spacer[200]}
    >
      <ConversationsDirectionFilter />
      <ConversationsAgentFilter />
      <ConversationsContactFilter />
      <ConversationsChannelFilter />
      <ConversationsQueueFilter />
      <ConversationsStatusFilter />

      <Button variant="secondary" onClick={handleClearAll}>
        Clear all
      </Button>
    </FlexBox>
  );
};
